import React, { Fragment } from "react"
import { Button, Divider, Form, Input, InputNumber, Progress, Radio, Row, Space, Typography } from "antd"
import { EuroOutlined } from "@ant-design/icons"
import { currencyFormater, getCurrencyFormater, getDeviseSymbol } from "../../i18n"

import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"

const { Text } = Typography

export default class MultiDettes extends React.Component {
    constructor(props) {
        super();
        this.state = {
            showMore: false
        }
    }

    render() {
        const { config, context, devise } = this.props
        const dettes = config.dettes

        const total = dettes.reduce((acc, item) => acc + item.montant, 0)
        const payed = dettes.reduce((acc, item) => acc + item.payed, 0)
        const reste = dettes.reduce((acc, item) => acc + item.reste, 0)

        const percent = payed * 100 / total

        const currencyFormater = getCurrencyFormater(context)

        const activeShowMore = dettes.length > 3

        let showedDettes = dettes
        if (activeShowMore && !this.state.showMore) {
            showedDettes = dettes.slice(0, 3)
        }

        return (
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column", padding: "0px 0%", paddingBottom: "20px" }}>
                <Form.Item noStyle shouldUpdate={true}>
                    {(form) => (
                        <Fragment>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 20,
                                padding: "20px 0%",
                                paddingBottom: 40
                            }}>
                                {showedDettes.map((item) => {
                                    return (
                                        <Text
                                            type="secondary">{item.name || t`Promesse`} ({item.payed > 0 ? currencyFormater(item.payed, 0, devise) + " / " + currencyFormater(item.montant, 0, devise) : currencyFormater(item.montant, 0, devise)})</Text>
                                    )
                                })}

                                {activeShowMore && !this.state.showMore && (
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%"
                                    }}>
                                        <Button
                                            onClick={() => this.setState({showMore: true})}>{t`Afficher tout`} ({dettes.length})</Button>
                                    </div>
                                )}
                            </div>

                            <Form.Item
                                label={t`Montant`}
                                name="montant"
                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                            >
                                <InputNumber
                                    size="large"
                                    min={1}
                                    placeholder={t`Montant`}
                                    addonAfter={form.getFieldValue("abo") ? (
                                        <Space>{getDeviseSymbol(context, devise)} {t`/ Mois`}</Space>
                                    ) : (getDeviseSymbol(context, devise))}
                                />
                            </Form.Item>

                            <Text>{t`Reste`} : {currencyFormater(reste, 0, devise)}</Text>

                            <Progress
                                percent={parseInt(percent)}
                                status="active"
                                strokeColor={{
                                    from: '#833ab4',
                                    to: '#c53cd4',
                                }}
                            />

                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: 20
                            }}>
                                <Radio.Group
                                    value={form.getFieldValue("abo")}
                                    optionType="button"
                                    buttonStyle="solid"
                                    onChange={(e => form.setFieldValue("abo", e.target.value))}
                                >
                                    <Radio value={false}><Trans>En une fois</Trans></Radio>
                                    <Radio value={true}><Trans>En plusieurs fois</Trans></Radio>
                                </Radio.Group>
                            </div>

                        </Fragment>
                    )}
                </Form.Item>
            </div>
        )
    }
}
